export function SkeletonGrid({ count = 8 }) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="overflow-hidden rounded-xl bg-white shadow-card">
          <div className="aspect-[4/3] animate-pulse bg-brand-shell" />
          <div className="space-y-3 p-4">
            <div className="h-4 w-3/4 animate-pulse rounded bg-brand-shell" />
            <div className="h-3 w-full animate-pulse rounded bg-brand-shell" />
            <div className="h-3 w-5/6 animate-pulse rounded bg-brand-shell" />
            <div className="flex items-center justify-between pt-2">
              <div className="h-4 w-16 animate-pulse rounded bg-brand-shell" />
              <div className="h-8 w-20 animate-pulse rounded bg-brand-shell" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
